import UniloginService from "@/common/api/unilogin.service";
import router from "@/router";

export const loginRequest = async (returnUrlRouteName, redirectUrl) => {
  const { href } = router.resolve({ name: returnUrlRouteName });
  const returnUrl = window.location.origin + href;

  try {
    const response = await UniloginService.request(returnUrl, redirectUrl);
    window.location.href = response.data.data.redirectUrl;
  } catch (e) {
    // This means it failed, the user will however already have gotten a notification in form of a toast
    // The interceptors in the /common/api/api.service.js will have given a toast
  }
};
